export default [
	{
		label: 'toggles.refundAccepted.yes',
		value: true
	},
	{
		label: 'toggles.refundAccepted.no',
		value: false
	}
]
